<template>
  <div class="reserve-container">
    <h1 class="title text-center pt-24 pb-4">{{$t('shared.reserve_area')}}</h1>
    <p class="sub-title font-bold text-center text-xl pb-6">
      {{$t('reservation_area.reservation_code')}}:
      <span class="text-turquoiseBlue"> {{ reservation.code }}</span>
    </p>
    <div class="container flex lg:flex-row flex-col justify-center">
      <div class="reserve-info w-full lg:pr-8">
        <div
          class="box-header mb-6"
          v-if="reservation.status !== 'boarding-passes'"
        >
          <div class="box-container box-container-top">
            <p class="parragraph-h-20">{{$t('reservation_area.status_reservation')}}</p>
          </div>
          <div class="box-container box-container-bot">
            <p class="text-sm">
              {{ config.fullDataEnteredText }}
            </p>
          </div>
        </div>
        <div
          class="box-header mb-6"
          v-if="reservation.status === 'boarding-passes'"
        >
          <div class="box-container box-container-top box-header-not-padding">
            <p class="parragraph-h-20">{{$t('reservation_area.boarding_passes')}}</p>
          </div>
          <div class="container-boarding-card flex flex-row flex-wrap p-2">
            <div v-for="boarding in reservation.boardings" :key="boarding.id">
              <a :href="boarding.file_path" download>
                <div class="boarding-card-area text-center m-2">
                  <div class="flex flex-col items-center justify-center h-full">
                    <img
                      class="boarding-img"
                      src="/img/icons/download-board.svg"
                    />
                    <p class="lg:text-xs text-sm font-bold pt-2">
                      {{ boarding.name }}
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <h3
          v-if="reservation.status === 'boarding-passes'"
          class="text-center text-3xl pt-2 pb-6 font-bold"
        >
          {{$t('shared.booking_summary')}}
        </h3>
        <div class="box-header mb-6">
          <div class="box-container box-container-top">
            <p class="parragraph-h-20">{{$t('reservation_area.passengers_data')}}</p>
          </div>
          <div class="box-container box-container-bot">
            <div
              class="flex lg: justify-between lg:flex-row flex-col"
              v-for="(passenger, index) in reservation.passengers"
              :key="passenger.id"
              :class="index + 1 !== reservation.passengers && reservation.passengers.length ? 'pb-4' : ''"
            >
              <p>
                {{ index + 1 }}ª {{$tc('shared.passenger', 1)}} ({{
                  getPassengerType(passenger.type)
                }})
              </p>
              <p class="font-bold">
                {{ passenger.name }} {{ passenger.last_name }}
              </p>
            </div>
          </div>
        </div>
        <div class="box-header box-header-not-padding mb-6">
          <div class="box-container box-container-top">
            <p class="parragraph-h-20">{{$t('shared.flight_details')}}</p>
          </div>
          <div class="box-container box-container-bot">
            <div class="flex lg:flex-row flex-col lg:justify-between">
              <div class="departure font-bold">
                <div class="flex items-center">
                  <img src="/img/icons/departure.svg" alt="Avión despegando" />
                  <p class="pl-4">
                    {{$t('shared.outbound')}}:
                    {{ formattedDateName(reservation.outbound_departure_time) }}
                    {{ formattedDate(reservation.outbound_departure_time) }}
                  </p>
                </div>
                <div v-if="reservation.passengers" class="passengers">
                  <p class="py-4">
                    <span class="capitalize">{{$tc('shared.passenger', 2)}}</span>: {{ reservation.passengers.length }}
                    {{
                      $tc('shared.passenger', reservation.passengers.length)
                    }}
                  </p>
                  <div class="flex justify-between">
                    <div class="flex flex-col">
                      <p class="lg:text-xs text-sm capitalize">{{$t('reservation_area.origin')}}</p>
                      <p v-if="reservation.origin" class="py-1">
                        {{ reservation.origin.name }} ({{
                          reservation.origin.code
                        }})
                      </p>
                      <p>
                        {{
                          formattedDateHour(reservation.outbound_departure_time)
                        }}
                      </p>
                    </div>
                    <div class="flex items-center">
                      <span class="text-semiDarkgrey px-4 lg:block hidden pb-7x"
                        >----------></span
                      >
                      <span class="text-semiDarkgrey px-4 lg:hidden block pb-7x"
                        >-----></span
                      >
                    </div>
                    <div class="flex flex-col items-end">
                      <p class="lg:text-xs text-sm capitalize">{{$t('reservation_area.destination')}}</p>
                      <p v-if="reservation.destination" class="py-1">
                        {{ reservation.destination.name }} ({{
                          reservation.destination.code
                        }})
                      </p>
                      <p>
                        {{
                          formattedDateHour(reservation.outbound_arrival_time)
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <br class="lg:hidden block" />
              <div class="arrival font-bold">
                <div class="flex items-center">
                  <img src="/img/icons/arrival.svg" alt="Avión despegando" />
                  <p class="pl-4">
                    Vuelta:
                    {{ formattedDateName(reservation.inbound_departure_time) }}
                    {{ formattedDate(reservation.inbound_departure_time) }}
                  </p>
                </div>
                <div v-if="reservation.passengers" class="passengers">
                  <p class="py-4">
                    Pasajeros: {{ reservation.passengers.length }}
                    {{
                      reservation.passengers.length > 1
                        ? "pasajeros"
                        : "pasajero"
                    }}
                  </p>
                  <div class="flex justify-between">
                    <div class="flex flex-col">
                      <p class="lg:text-xs text-sm">{{$t('reservation_area.origin')}}</p>
                      <p class="py-1">
                        {{ reservation.destination.name }} ({{
                          reservation.destination.code
                        }})
                      </p>
                      <p>
                        {{
                          formattedDateHour(reservation.inbound_departure_time)
                        }}
                      </p>
                    </div>
                    <div class="flex items-center">
                      <span class="text-semiDarkgrey px-4 lg:block hidden pb-7x"
                        >----------></span
                      >
                      <span class="text-semiDarkgrey px-4 lg:hidden block pb-7x"
                        >-----></span
                      >
                    </div>
                    <div class="flex flex-col items-end">
                      <p class="lg:text-xs text-sm">{{$t('reservation_area.destination')}}</p>
                      <p class="py-1">
                        {{ reservation.origin.name }} ({{
                          reservation.origin.code
                        }})
                      </p>
                      <p>
                        {{
                          formattedDateHour(reservation.inbound_arrival_time)
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-price" v-if="config.showPrice">
            <div class="bg-mediumGrey flex justify-between font-bold py-2 px-5">
              <p>{{$t('shared.flight_price')}} x{{reservation.passengers && reservation.passengers.length }}:</p>
              <p>{{ reservation.flight_price_per_passenger | currency }}</p>
            </div>
          </div>
        </div>
        <div class="box-header mb-6" v-if="reservation.accommodation">
          <hotel-card
            :hotel="hotel"
            :onlyInfo="true"
            :adults="adults"
            :nights="nights"
            :destination="reservation.destination.name"
          >
          </hotel-card>
        </div>
        <div class="box-header box-header-not-padding mb-6">
          <div class="box-container box-container-top">
            <p v-if="config.baggageInfo" class="parragraph-h-20">{{$t('reservation_area.luggage_included_ebm')}}</p>
            <p v-else class="parragraph-h-20">{{$t('reservation_area.luggage_included')}}</p>
          </div>
          <div class="box-container box-container-bot">
            <div class="flex">
              <img
                src="/img/icons/icons-extra-bag.svg"
                alt="Avión despegando"
                class="self-start"
              />
              <div class="flex lg:flex-row flex-col">
                <div class="flex flex-col pl-4" v-if="config.baggageInfo">
                  <ul class="list-disc mb-3">
                    <li>{{$t('reservation_area.handbag_seven_kg')}}</li>
                    <li>{{$t('reservation_area.checked_bag_twenty_kg')}}</li>
                  </ul>
                  <p class="ml-4">{{$t('reservation_area.included_in_flights')}}</p>
                </div>
                <div class="flex flex-col pl-4" v-else >
                  <p class="font-bold pb-2">{{$t('shared.hand_bag')}}</p>
                  <p>{{$t('wizard_more_days.handbag_or_backpack')}}</p>
                  <p>
                    {{$t('shared.you_may_carry_a_bag')}}
                  </p>
                </div>

                <div
                  class="
                    text-turquoiseBlue
                    flex
                    align-end
                    lg:justify-end lg:pt-0
                    pt-4
                    lg:pl-0
                    pl-4
                  "
                >
                  <img src="/img/icons/check.svg" alt="Avión despegando" />
                  <p class="text-sm font-bold pl-1">{{$t('shared.included')}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-header mb-6" v-if="reservation.extras ? reservation.extras.length : computedBags.length">
          <div class="box-container box-container-top">
            <p class="parragraph-h-20">{{$t('shared.extras_added')}}</p>
          </div>
          <div
            class="box-container box-container-bot"
            v-for="extra in reservation.extras"
            :key="extra.id"
          >
            <div class="flex justify-between flex-row lg:pl-2">
              <div class="flex items-center">
                <img
                  :src="'/img/icons/extras/' + extra.slug + '.svg'"
                  class="self-start"
                />
                <div class="pl-4">
                  <p class="font-bold">
                    {{ extra.title }} x {{ extra.pivot.quantity }}
                  </p>
                </div>
              </div>
              <div
                class="
                  container-add-extra
                  flex flex-col
                  items-end
                  lg:w-5/12 lg:pl-4
                  justify-end
                  lg:justify-center
                "
              >
                <p class="font-bold pl-1 lg:pl-0">
                  {{ extra.pivot.price | currency }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="box-container box-container-bot"
            v-for="bag in computedBags"
            :key="bag.id"
          >
            <div class="flex justify-between flex-row lg:pl-2">
              <div class="flex items-center">
                <img v-if="bag.icon" :src="`/img/icons/${bag.icon}`" />
                <div class="pl-4 flex flex-col">
                  <p class="font-bold">
                    {{ bag.name }}
                  </p>
                  <p class="">
                    {{ bag.description }}
                  </p>
                </div>
              </div>
              <div
                class="
                  container-add-extra
                  flex flex-col
                  items-end
                  lg:w-5/12 lg:pl-4
                  justify-end
                  lg:justify-center
                "
              >
                <p class="font-bold pl-1 lg:pl-0">
                  {{ bag.price | currency }}
                </p>
              </div>
            </div>
          </div>
          <div class="box-price">
            <div class="bg-mediumGrey flex justify-between font-bold py-2 px-5">
              <p>Total extras</p>
              <p>{{ totalExtras | currency}}</p>
            </div>
          </div>
        </div>

        <div v-if="gotFlexExtras" class="w-full flex items-center justify-center">
          <button class="text-base text-semiDarkgrey hover:underline full-width flex justify-center" @click="openPopup()">{{ $t('reservation_area.cancel_reservation') }}</button>
        </div>

        <div v-if="config.showExtras">
          <div v-if="showAddExtras">
            <h3 class="text-3xl text-center font-bold mt-8 mb-4">{{$t('reservation_area.add_extra')}}</h3>
            <div v-for="extra in extrasBags" :key="extra.id">
              <div class="box-header mb-6" v-if="!extra.included">
                <div
                  class="lg:p-6 p-4 flex lg:justify-between lg:flex-row flex-col"
                >
                  <div class="flex">
                    <img :src="'/img/icons/' + extra.icon" class="self-start" />
                    <div class="pl-4">
                      <p class="font-bold">{{ extra.name }}</p>
                      <p class="pt-2">{{ extra.description }}</p>
                    </div>
                  </div>
                  <div
                    class="
                      container-add-extra
                      flex flex-col
                      items-end
                      lg:w-5/12 lg:pl-4
                    "
                  >
                    <p class="font-bold pb-2">+{{ extra.price | currency }}</p>
                    <v-btn
                      class="w-full search-style add-extra"
                      color="secondary"
                      rounded
                      elevation="0"
                      @click="addExtras"
                    >
                      <span class="font-bold pr-2 text-base">{{$t('reservation_area.add')}}</span>
                      <img src="/img/icons/plus.svg" />
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="box-header mb-6"
              v-for="(extra, index) in extrasAvaliable"
              :key="index"
            >
              <div
                v-if="extrasAvaliable.length !== 0"
                class="lg:p-6 p-4 flex lg:justify-between lg:flex-row flex-col"
              >
                <div class="flex">
                  <img
                    :src="'/img/icons/extras/' + extra.slug + '.svg'"
                    class="self-start"
                  />
                  <div class="pl-4">
                    <p class="font-bold">
                      {{ extra.pivot ? extra.pivot.title : extra.title }}
                    </p>
                    <p class="pt-2">
                      {{
                        extra.pivot ? extra.pivot.description : extra.description
                      }}
                    </p>
                  </div>
                </div>
                <div
                  class="
                    container-add-extra
                    flex flex-col
                    items-end
                    lg:w-5/12 lg:pl-4
                  "
                >
                  <p class="font-bold pb-2">
                    +{{
                      (extra.pivot ? extra.pivot.price : extra.price) | currency
                    }}/pasajero
                  </p>
                  <v-btn
                    class="w-full search-style add-extra"
                    color="secondary"
                    rounded
                    elevation="0"
                    @click="addExtras"
                  >
                    <span class="font-bold pr-2 text-base">{{$t('reservation_area.add')}}</span>
                    <img src="/img/icons/plus.svg" />
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="reserve-pdf" v-if="reservation.destination && reservation.destination.itinerary">
        <div class="box-header bg-navy text-white p-4">
          <div class="flex flex-col">
            <img
              class="mb-4"
              :src="'/storage/' + reservation.destination.blog_banner_image"
            />
            <h3 class="font-bold text-xl">
              {{$t('shared.find_out_more_things')}}
              {{ reservation.destination.name }}
            </h3>
            <a
              :href="
                '/blog/que-ver-en-' +
                reservation.destination.slug +
                '-en-un-dia'
              "
            >
              <v-btn
                class="button-pdf w-full search-style mt-6"
                color="secondary"
                rounded
                elevation="0"
              >
                <span class="font-bold text-base">{{$t('reservation_area.read_more_blog')}}</span>
              </v-btn>
            </a>
            <a :href="'/storage/' + reservation.destination.itinerary" download>
              <v-btn
                class="button-pdf w-full search-style mt-6 mb-4"
                color="secondary"
                rounded
                elevation="0"
              >
                <span class="font-bold text-base">{{$t('reservation_area.download_pdf')}}</span>
              </v-btn>
            </a>
          </div>
        </div>
      </div>
    </div>
    <popup :code="reservation.code">
      <p class="text-center">{{ $t('reservation_area.confirm_cancel') }}</p>
      <textarea v-model="observation" id="cancelObservation" rows="3" :placeholder="$t('global.observations')"></textarea>
      <div class="buttons">
        <v-btn rounded color="secondary"  elevation="0" class="avm-btn" @click="cancelReservation(reservation.code)">
          {{ $t('global.accept') }}
        </v-btn>
        <v-btn rounded color="cancel" dark elevation="0" class="avm-btn" @click="closePopup()">
          {{ $t('global.cancel') }}
        </v-btn>
      </div>
    </popup>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  GET_RESERVATION,
  GET_AVALIABLE_EXTRAS,
  GET_EXTRAS_TO_ADD,
  GET_ANY_BAGS_TO_ADD,
} from "../../store/reserve-area/getter-types";
import moment from "moment";
import HotelCard from "../nights/accommodation/HotelCard.vue";
import Popup from "../../components/Popup/Popup.vue";
import Axios from 'axios';
import { SET_SNACKBAR } from '../../store/snackbar/mutation-types';

export default {
  components: {
    HotelCard,
    Popup
  },
  data() {
    const appConfig = window.appConfig || 'avm';
    return {
      observation: "",
      config: {
        showPrice: appConfig === 'avm',
        showExtras: appConfig === 'avm',
        baggageInfo: appConfig === 'ebm' ,
        fullDataEnteredText: appConfig === 'ebm'
        ? this.$t('reservation_area.full_data_entered_ebm')
        : this.$t('reservation_area.full_data_entered')
      }
    };
  },
  computed: {
    ...mapGetters({
      reservation: GET_RESERVATION,
      extrasAvaliable: GET_AVALIABLE_EXTRAS,
      extrasToAdd: GET_EXTRAS_TO_ADD,
      anyBagsToAdd: GET_ANY_BAGS_TO_ADD,
    }),
    totalExtras() {
      let sum = 0;
      this.reservation.extras.forEach((extra) => {
        sum += extra.pivot.price * extra.pivot.quantity;
      });
      this.computedBags.forEach((bag) => {
        sum+= parseFloat(bag.price);
      })
      return sum;
    },
    extrasBags() {
      return this.$store.state.nights.resources.bags;
    },
    hotel() {
      let clone = {
        ...this.reservation.accommodation,
        categoryCode: this.reservation.accommodation.category,
      };
      return clone || null;
    },
    adults() {
      let sum = 0;
      this.reservation.passengers.forEach((passenger) => {
        if (passenger.type === "adult") sum++;
      });
      return sum;
    },
    nights() {
      return moment(this.reservation.inbound_departure_time).diff(
        moment(this.reservation.outbound_departure_time),
        "days"
      );
    },
    showAddExtras() {
      if (this.reservation.status === "boarding-passes") return false;

      return (
        (this.extrasToAdd.length || this.anyBagsToAdd) &&
        this.reservation.status === "data-sent"
      );
    },
    computedBags() {
      let bags = [];
      if(!this.reservation.passengers) return [];

      this.reservation.passengers.forEach((passenger) => {
        bags.push(
          passenger.bags.map((b) => {
            return {
              ...b,
              icon: this.getIconBag(b.description),
            };
          })
        );
      });

      return bags.flat();
    },
    gotFlexExtras(){
      return this.reservation.flex_extras.length;
    },
  },
  methods: {
    getIconBag(description) {
      switch (description) {
        case "10Kg":
          return "suitcase-2.svg";
        case "20Kg":
          return "luggage-2.svg";
        default:
          return "suitcase-2.svg";
      }
    },
    addExtras() {
      this.$router.push({
        name: "reserve-area-extras",
        params: { code: this.reservation.code },
      });
    },
    getPassengerType(typeValue) {
      switch (typeValue) {
        case "adult":
          return this.$i18n.messages[this.$i18n.locale].reservation_area.adult;
        case "child":
          return this.$i18n.messages[this.$i18n.locale].reservation_area.child;
        case "baby":
          return this.$i18n.messages[this.$i18n.locale].reservation_area.baby;
        default:
          return this.$i18n.messages[this.$i18n.locale].reservation_area.passenger;
      }
    },
    formattedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formattedDateName(date) {
      return moment(date).locale("es").format("dddd");
    },
    formattedDateHour(date) {
      return moment(date).format("HH:mm") + "h";
    },
    lowercase(value) {
      return value.toLowerCase();
    },
    cancelReservation(code) {
      Axios.get(`/api/cancelation/${code}/${this.observation}`).then(res => {
        this.closePopup();
        this.$store.commit(SET_SNACKBAR, {
          ...store.getters.GET_SNACKBAR,
          text: res.data.message,
          color: "success",
          value: true,
        });
      });
    },
    openPopup(){
      Event.$emit('open-popup');
    },
    closePopup(){
      Event.$emit('close-popup');
    }
  },
};
</script>

<style lang="scss">
@import "../../../sass/_variables.scss";

.reserve-container {
  .title {
    font-size: 45px !important;
  }
  .box-header-not-padding {
    padding: 0 !important;
  }

  .reserve-info {
    width: 788px;
    @media (max-width: 1023px) {
      width: 100%;
    }
    .box-header {
      .box-container-top {
        padding: 0.9rem 0rem 0.75rem 1.2rem !important;
      }
      .box-container-bot {
        padding: 1.2rem !important;
      }

      .box-price {
        border-top: solid 1px $brownGrey;
        border-bottom-right-radius: 15px;
        border-bottom-left-radius: 15px;
      }
      .container-add-extra {
        justify-content: space-between;
        @media (max-width: 1023px) {
          margin-top: 1rem;
          flex-direction: row;
        }
      }
    }
    .full-width{
      width: 100%;
    }

    button {
      min-width: 0 !important;
      width: auto;
      height: 2.5rem !important;
      padding: 1rem 1.25rem !important;
      @media (max-width: 1023px) {
        display: flex;
        justify-content: space-between;
        width: 9rem;
      }
    }
  }

  .reserve-pdf {
    width: 322px;
    @media (max-width: 1023px) {
      width: 100%;
    }
    .box-header {
      .button-pdf {
        background-color: transparent !important;
        border: solid 1px $turquoiseBlue;
        height: 3rem !important;
      }

      img {
        border-radius: 15px;
      }
    }
  }

  .container-boarding-card {
    @media (max-width: 422px) {
      flex-direction: column !important;
    }
    .boarding-card-area {
      width: 146px;
      height: 123px;
      cursor: pointer;
      border-radius: 10px;
      border: solid 1px $turquoiseBlue;
      @media (max-width: 422px) {
        width: 95%;
      }
    }
  }

  .boarding-img {
    width: 40px;
  }
  .pb-7x {
    padding-bottom: 7px;
  }
  .box-container-extras:first-child {
    border-top: solid 1px #979797;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: $semiDarkgrey;
  }
}

textarea{
  border: 1px solid rgba(104, 104, 104, 0.482);
  border-radius: 5px;
  width: 100%;
  margin: 10px 0;
  padding: .25rem;
  resize: none;
}
</style>
